import React from 'react'
import Wclothes from './Wclothes'
function Women() {
  return (
    <div className='men-c'>
      <div className='W-pics'>
        <img src="https://i.pinimg.com/736x/c4/18/23/c4182362ca6916d6231026135adab584.jpg" alt="" />
        <img src="https://www.elahe.in/cdn/shop/files/SVV-5037copy_2048x.jpg?v=1713014692" alt="" />
      </div>
      <div className='W-text'>
        <h2>Elegance and Tradition: Women's Wedding Lehenga Collection</h2>
        <p>A wedding is the most cherished occasion in a woman's life, and choosing the perfect lehenga is a moment filled with excitement and emotions. The bridal lehenga is more than just an outfit; it is a symbol of grace, culture, and timeless beauty. Designed to enhance the elegance of the bride, wedding lehengas come in a variety of colors, fabrics, and intricate embroidery patterns.
          <br />
          A bridal lehenga is traditionally a three-piece ensemble consisting of a long, flowing skirt (lehenga), a fitted blouse (choli), and a beautifully embroidered dupatta. Each element of the lehenga is designed to create a regal and enchanting look, making the bride feel like royalty on her special day. From classic reds to pastel hues, the color of the lehenga reflects the personality and style of the bride.
          <br />
          The beauty of a wedding lehenga lies in its intricate embroidery and craftsmanship. Embellished with zardozi, threadwork, sequins, and mirror work, each lehenga tells a unique story. The hand-embroidered motifs inspired by floral patterns, paisleys, and traditional artwork add charm and sophistication to the outfit. Brides can also opt for heavily embroidered lehengas for a majestic look or subtle embellishments for a contemporary touch.
        </p>
      </div>
      <h2>Find Your Perfect Look</h2>
      <Wclothes/>
    </div>
  )
}
export default Women